import React from 'react';

const GameBaccarat = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21 4.25C21.9665 4.25 22.75 5.0335 22.75 6V14.8496C22.75 15.0881 22.6771 15.3201 22.542 15.5146L22.4795 15.5957C17.1108 22.038 7.28712 22.1386 1.7793 15.8975L1.52051 15.5957C1.34594 15.3862 1.25004 15.1223 1.25 14.8496V6C1.25 5.0335 2.0335 4.25 3 4.25H21ZM3 5.75C2.86193 5.75 2.75 5.86193 2.75 6V14.7256C7.59553 20.4294 16.4045 20.4294 21.25 14.7256V6C21.25 5.86193 21.1381 5.75 21 5.75H3ZM10 14C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15C9 14.4477 9.44771 14 10 14ZM14 14C14.5523 14 15 14.4477 15 15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15C13 14.4477 13.4477 14 14 14ZM6 12C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12ZM18 12C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14C17.4477 14 17 13.5523 17 13C17 12.4477 17.4477 12 18 12ZM18 9.75H6V8.25H18V9.75Z",
      fill: "white"
    }
  )
);

export { GameBaccarat };
//# sourceMappingURL=GameBaccarat.js.map
